export const LOCAL_STORAGE_TICKER_OPEN = 'tickerOpen';
export const LOCAL_STORAGE_LAST_TICKER_OPENING = 'lastTickerOpening';
export const LOCAL_STORAGE_TOKEN = 'token';
export const LOCAL_STORAGE_SIGNIN_ATTEMPTS = 'signInAttempts';
export const LOCAL_STORAGE_ROOT_LOADER_ATTEMPTS = 'rootLoaderAttempts';
export const LOCAL_STORAGE_SHOW_MOBILE_SHORTCUT_MESSAGE = 'hasLoggined';
export const LOCAL_STORAGE_SELECTED_COMMUNITY = 'selectedSchool';
